export enum UploadFailureNotification {
  FileLimitError = `Too many files: please upload no more than 5 documents at the same time.`,
  LargeDocument = 'The document is larger than 10 Mb and cannot be uploaded.',
  DocumentNotUploaded = 'The document has not been uploaded.',
  EncryptedDocument = 'The document you attempted to upload cannot be read as it is encrypted / password protected. Please re-upload.',
}
